import _default from './Sidebar';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/modules/Sidebar/index.js
// module id = 3351
// module chunks = 0